export class  ProjectDisk {
  constructor(
    public readonly url: string,
    public readonly files: ProjectFile[],
  ) {
  }

  static fromJson(json: any): ProjectDisk {
    return new ProjectDisk(
      String(json['url']),
      json['files'].map((json: any) => ProjectFile.fromJson(json)),
    );
  }
}
export type ProjectFileType = 'Correspondentie' | 'Fotos' | 'Offerte-calculatie' | 'Rekenbladen' | 'Scans' | 'Werkbon' | 'Algemeen' | 'Bestellingen'
export class ProjectFile {
  constructor(
    public readonly path: string,
    public readonly projectPath: string,
    public readonly type: ProjectFileType,
    public readonly name: string,
    public readonly url: string,
  ) {
  }

  static fromJson(json: any): ProjectFile {
    return new ProjectFile(
      String(json['path']),
      String(json['project_path']),
      String(json['type']) as ProjectFileType,
      String(json['name']),
      String(json['url']),
    );
  }
}